import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form';
import submit from './submit';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
//Style
import cx from 'classnames';
import { Button, Form } from 'react-bootstrap';

import Loader from '../../Common/Loader/Loader';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import messages from '../../../locale/messages';
import validate from './validate';
import { formatLocale } from '../../../helpers/formatLocale';

import { AddContentPlusIcon, DeleteContentPlusIcon } from '../../Common/Assets/SVGIcon/CommonSvgRemainingIcon';

import bt from '../../../components/commonStyle.css';
import s from './CitySettingsForm.css';
export class CitySettingsForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedLanguages: []
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { dynamicCategoryTitle } = nextProps;
        let filteredLanguages = dynamicCategoryTitle?.map((item) => { return item?.language })
        this.setState({ selectedLanguages: filteredLanguages });
    }




    renderFieldArray = ({ fields, meta: { touched, error } }) => {
        const { formatMessage } = this.props.intl;
        const { languageList } = this.props;
        const { selectedLanguages } = this.state;

        return (

            <div className={bt.languageBox}>
                {fields && fields.map((category, index) => {
                    let fieldLength = fields.length - 1;
                    const currentLanguage = fields?.get(index)?.language;
                    const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
                    const languagesOption = [{ value: '', label: formatMessage(messages.chooseLanguageLabel) }];
                    const languageOptionsFormatted = availableLanguages.map((locale) => {
                        return {
                            value: locale,
                            label: formatLocale(locale)
                        };
                    });

                    languagesOption.push(...languageOptionsFormatted);
                    return (
                        <div key={index}>
                            <div className='twoColumnGrid'>
                                <Field
                                    name={`${category}.language`}
                                    component={SelectFieldComponent}
                                    label={formatMessage(messages.language)}
                                    options={languagesOption}
                                    inputClass={cx(bt.formControlSelect)}
                                />

                                <Field
                                    name={`${category}.value`}
                                    type="text"
                                    component={InputFieldComponent}
                                    label={formatMessage(messages.categoryTitle)}
                                    placeholder={formatMessage(messages.categoryTitle)}
                                    autoComplete={false}
                                    inputClass={bt.formControlInput} />
                            </div>
                            <div className={cx(bt.languageBtnContainer, 'svgImg', { [bt.languageBtnContainerOne]: (fieldLength > 0) })} >
                                {(fields.length <= languageList?.length - 1) && fieldLength == index &&
                                    <Button className={cx(bt.languageBtn)} onClick={() => fields.length <= languageList?.length - 1 && fields.push({})}>
                                        <AddContentPlusIcon />
                                        <span>	{formatMessage(messages.addLanguage)}</span>
                                    </Button>
                                }

                                {fieldLength > 0 && <div>
                                    <Button className={cx(bt.languageBtn, bt.languageDeleteBtn)} onClick={() => fields.remove(index)}>
                                        <DeleteContentPlusIcon />
                                        <span>{formatMessage(messages.deleteLanguage)}</span>
                                    </Button>
                                </div>}
                            </div>
                        </div>
                    )
                })}
            </div >
        )
    }


    render() {
        const { handleSubmit, loading, submitting } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.citySectionSettings)}</h1>
                <FieldArray name='citySectionTitle1' rerenderOnEveryChange={true} component={this.renderFieldArray} />

                <div className={cx(bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'singleFlexEndBtn')}>
                    <Loader
                        type={"button"}
                        label={formatMessage(messages.submitButton)}
                        show={loading}
                        buttonType={'submit'}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                        disabled={submitting || loading}
                    />
                </div>
            </Form>
        )
    }
}


const selector = formValueSelector('CitySettingsForm')

CitySettingsForm = reduxForm({
    form: 'CitySettingsForm',
    onSubmit: submit,
    validate
})(CitySettingsForm);
const mapState = (state) => ({
    dynamicCategoryTitle: selector(state, 'citySectionTitle1'),
    languageList: state?.runtime?.availableLocales,
    loading: state?.loader?.CitySettingsForm,
})
const mapDispatch = {
}
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(CitySettingsForm)));
